import React from 'react';
import {Table, Input, Checkbox, Button} from 'semantic-ui-react';

const DisplayData = ({item, idx, handleUpdateAmount, handleRemoveItem, handleUpdatePrincipalPart, disabledBtns}) => {
  const {principalPart, id, fr, description, quantity, price,
    priceTde, cost, fob, priceClaimProvider = 0} = item;
  const finalPrice = priceTde ? (priceTde === 0 ? priceClaimProvider : priceTde) : priceClaimProvider;
  return (
    <Table.Row key={id}>
      <Table.Cell>
        <Checkbox
          disabled={disabledBtns}
          onChange={(e, data) => handleUpdatePrincipalPart(data, item)}
          checked={principalPart === 'S'}/>
      </Table.Cell>
      <Table.Cell>
        {id}
      </Table.Cell>
      <Table.Cell>
        {fr}
      </Table.Cell>
      <Table.Cell>
        {description}
      </Table.Cell>
      <Table.Cell>
        {quantity}
      </Table.Cell>
      <Table.Cell>
        {'$'}{price.toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        {'$'}{price.toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-part-input'
          placeholder='Precio TDE'
          value={finalPrice || 0}
          type='number'
          min='0'
          step='0.1'
          disabled={disabledBtns}
          onChange={(e, {value}) => handleUpdateAmount('priceTde', value, item)}/>
      </Table.Cell>
      <Table.Cell>
        {'$'}{cost.toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        {'$'}{fob.toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        {'$'}{priceClaimProvider.toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        {'$'}{(+quantity * +price).toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        {'$'}{(+quantity * +priceTde).toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        <Button
          disabled={disabledBtns}
          onClick={() => handleRemoveItem(idx)}
          size='mini'
          color="red">
            Eliminar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

export default DisplayData;
